<ng-template #contentProjection>
    <ng-content></ng-content>
</ng-template>

<button
    [ngClass]="{
        'paragraph-xsmall': true,
    }"
    [attr.title]="title">
    <ng-container *ngTemplateOutlet="contentProjection"></ng-container>
</button>
